<template>
  <v-row class="py-10 px-5 grey lighten-4 fill-height">
    <v-col cols="12">
      <v-row>
        <v-col cols="12" md="3" class="pa-0 ma-0">
        </v-col>
        <v-col cols="12" md="6" LOGO>
          <v-card class="text-center py-5 elevation-2 align-center">
            <img v-if="site.logo" :src="site.logo" height="70" alt="">
            <span v-if="!site.logo" class="headline">{{site.name}}</span>
          </v-card>
        </v-col>
        <v-col cols="12" md="3" class="pa-0 ma-0">
        </v-col>
        <v-col cols="12" md="3" class="pa-0 ma-0">
        </v-col>
        <v-col cols="12" md="6" SEARCH-RESULT>
          <v-card class="px-3" :loading="loading">
            <v-card-text v-if="searchView">
              <v-row class="pa-0">
                <v-col cols="12" style="font-size:18px;" :class="`${arabic?'arFont':'enFont'} pa-0 py-2 font-weight-bold`">
                  تسجيل الدخول
                </v-col>
                <v-col cols="12" style="font-size:16px;line-height:2;" :class="`${arabic?'arFont':'enFont'} pa-0 py-2`">
                  <v-row class="align-center">
                    <v-col cols="12" :class="`${arabic?'arFont':'enFont'} text-center pa-0 ma-0`">
                      <v-row class="align-center">
                        <v-col cols="6" :class="`${arabic?'arFont':'enFont'} text-center pa-0 ma-0`">
                          <v-btn color="primary" text :disabled="phonelogin" @click="()=>{phonelogin = true;emaillogin = false}" :class="`${arabic?'arFont':'enFont'}`">الدخول عبر رقم الهاتف</v-btn>
                        </v-col>
                        <v-col cols="6" :class="`${arabic?'arFont':'enFont'} text-center pa-0 ma-0`">
                          <v-btn color="primary" text :disabled="emaillogin" @click="()=>{phonelogin = false;emaillogin = true}" :class="`${arabic?'arFont':'enFont'}`">الدخول عبر الايميل</v-btn>
                        </v-col>
                      </v-row>
                    </v-col>

                    <v-col cols="12" style="font-size:16px;line-height:2;" :class="`${arabic?'arFont':'enFont'} pa-2`" v-if="phonelogin">
                      <v-text-field
                        outlined
                        autofocus
                        hide-details
                        v-model="search_number"
                        @keydown.enter="searchLead()"
                        :class="`${arabic?'arFont':'enFont'} pa-2`"
                        label="رقم الهاتف"
                        id="id"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" style="font-size:16px;line-height:2;" :class="`${arabic?'arFont':'enFont'} pa-2`" v-if="emaillogin">
                      <v-text-field
                        outlined
                        autofocus
                        hide-details
                        v-model="search_email"
                        @keydown.enter="searchLeadEmail()"
                        :class="`${arabic?'arFont':'enFont'} pa-2`"
                        label="الايميل"
                        id="id"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" style="font-size:18px;" :class="`${arabic?'arFont':'enFont'} pa-4 py-2 error--text`" v-if="error">
                      في حال عدم تمكنك من الدخول للتأكد من نتيجة ملفك يرجى الاتصال بمكتبنا في بلدك بشكل مباشر
                    </v-col>
                    <v-col cols="12" style="font-size:18px;" :class="`${arabic?'arFont':'enFont'} pa-4 py-2`" v-if="phonelogin">
                      <v-btn x-large :class="`${arabic?'arFont':'enFont'}`" color="primary" block @click="searchLead()">الدخول عبر رقم الهاتف</v-btn>
                    </v-col>
                    <v-col cols="12" style="font-size:18px;" :class="`${arabic?'arFont':'enFont'} pa-4 py-2`" v-if="emaillogin">
                      <v-btn x-large :class="`${arabic?'arFont':'enFont'}`" color="primary" block @click="searchLeadEmail()">الدخول عبر الايميل</v-btn>
                    </v-col>
                    <v-col cols="12" style="font-size:12px;" :class="`${arabic?'arFont':'enFont'} text-center px-6 py-1`">
                      هذا النظام خاص بتتبع الموافقات للمترشحين في مختلف البرامج شركة ارامكو في المانيا لضمان افضل مستوى من الشفافية وسهولة التواصل مع المترشحين
                    </v-col>
                    <v-col cols="12" style="font-size:11px;" :class="`${arabic?'arFont':'enFont'} text-center px-6 py-1`" v-if="location">
                      {{location.country_code2}} | {{location.country_name}} | {{location.ip}} | <img height="10px" :src="location.country_flag" alt="">
                    </v-col>
                    <v-col cols="12" :class="`${arabic?'arFont':'enFont'} pa-4 py-2`">
                      <v-btn :class="`${arabic?'arFont':'enFont'}`" color="primary" block @click="openLink('https://events.aramccogermany.com/')">انجازات ارامكو</v-btn>
                    </v-col>
                  </v-row>
                </v-col>
                
              </v-row>
            </v-card-text>
            <v-card-text v-if="resultView">
              <v-row class="pa-0">
                <v-col cols="12" style="font-size:18px;" :class="`${arabic?'arFont':'enFont'} pa-0 py-2 `">
                  <div>هذه النتيجة خاصة بالمترشح</div>
                  <div class="font-weight-bold pt-1"> {{lead.name}}</div>
                </v-col>
                <v-col cols="12" style="font-size:15px;" :class="`${arabic?'arFont':'enFont'} pa-0 py-2 font-weight-bold`">
                  
                  <div>الاسم: {{lead.name}}</div>
                  <div class="py-1">الهاتف: <v-chip color="grey lighten-4" label small>{{lead.phone}}</v-chip></div>
                  <div class="py-1">البرنامج: <v-chip color="grey lighten-4" label small>{{lead.program_name ? lead.program_name.ar : lead.program}}</v-chip></div>
                  <div class="py-1">البلد: <v-chip color="grey lighten-4" label small>{{lead.country_name ? lead.country_name.ar : lead.country}}</v-chip></div>
                  <div class="py-1">يوم المقابلة: <v-chip color="grey lighten-4" label small>{{day}}</v-chip></div>
                  <div class="py-1">تاريخ المقابلة: <v-chip color="grey lighten-4" label small>{{date}}</v-chip>
                  
                  </div>
                </v-col>
                <v-col cols="12" style="font-size:18px;" :class="`${arabic?'arFont':'enFont'} pa-0 py-2`" v-if="!result_ready">
                  <v-alert
                    icon="event"
                    border="top"
                    colored-border
                    type="info"
                    elevation="2"
                  >
                    <div class="font-weight-bold pb-2">لا زالت نتيجة الملف لم تصدر بعد</div>
                    <div>تصدر النتائج بعد الساعة التاسعة مساء بتوقيت المانيا</div>
                  </v-alert>
                </v-col>
                <v-col cols="12" :class="`${arabic?'arFont':'enFont'} pa-0 py-2`" v-if="!result_ready">
                  <v-btn :class="`${arabic?'arFont':'enFont'}`" color="primary" block @click="openLink('https://events.aramccogermany.com/')">انجازات ارامكو</v-btn>
                </v-col>
                <v-col cols="12" style="font-size:18px;" :class="`${arabic?'arFont':'enFont'} pa-0 py-2`" v-if="result_ready && !accepted">
                  <v-alert
                    icon="close"
                    border="top"
                    type="error"
                    elevation="2"
                  >
                    <div class="pb-2">نعتذر منك</div>
                    <div class="pb-2">للأسف لم يتم الموافقة على طلبك للأنضمام لبرنامج {{lead.program_name ? lead.program_name.ar : lead.program}} الخاص بشركة ارامكو في المانيا</div>
                  </v-alert>
                </v-col>
                <v-col cols="12" style="font-size:18px;" :class="`${arabic?'arFont':'enFont'} pa-0 py-2`" v-if="result_ready && accepted">
                  <v-alert
                    icon="verified"
                    border="top"
                    type="success"
                    elevation="2"
                  >
                    <div class="pb-2">مبروك</div>
                    <div class="pb-2">حصلت على الموافقة النهائية لطلبك للأنضمام لبرنامج {{lead.program_name ? lead.program_name.ar : lead.program}} الخاص بشركة ارامكو في المانيا</div>
                  </v-alert>
                </v-col>
                <v-col cols="12" style="font-size:18px;" :class="`${arabic?'arFont':'enFont'} pa-0 py-2`" v-if="result_ready && accepted && voucherTime">
                  <v-alert
                    icon="redeem"
                    border="top"
                    colored-border
                    type="success"
                    elevation="2"
                  >
                    <div class="pb-2">خصم خاص بك</div>
                    <div class="pb-2">
                      <v-icon size="12" color="success" dark>check_circle</v-icon>
                      <span class="font-weight-bold">{{lead.name}}</span>
                      لقد اختارك نظام الموافقات للحصول على خصم خاص وهو صالح لمدة يوم واحد فقط وهو يوم غد الموافق:
                    </div>
                    <div class="pb-2">
                      <v-icon size="12" color="success" dark>calendar_month</v-icon>
                      <span class="font-weight-bold">{{voucherTime}}</span>
                    </div>
                    <div class="pb-2">
                      <v-icon size="12" color="success" dark>check_circle</v-icon>
                      يرجى طباعة الخصم الخاص بك عبر الضغط هنا واصطحابه الى مكتبنا في
                      <span class="font-weight-bold">{{lead.country_name ? lead.country_name.ar : lead.country}}</span>
                      عند التسجيل
                    </div>
                    <div class="pb-2">
                      <v-btn color="success" small @click="openLink(voucherLink)">
                        الخصم 
                        |
                        Voucher
                      </v-btn>
                    </div>
                    
                    
                  </v-alert>
                </v-col>
                <v-col cols="12" style="font-size:18px;" :class="`${arabic?'arFont':'enFont'} pa-0 py-2`" v-if="result_ready && accepted && lead && lead.country_name && false">
                  <v-alert
                    icon="verified"
                    border="top"
                    colored-border
                    type="success"
                    elevation="2"
                  >
                    <div class="pb-2">ملاحظة</div>
                    <div class="pb-2">هذه الموافقة صالحة حتى يوم 
                      <span class="font-weight-bold">{{last_day}}</span>
                      الموافق 
                      <span class="font-weight-bold">{{last_date}} </span>
                      حتى تمام الساعة 
                      <span class="font-weight-bold">{{last_time}}</span>
                      </div>
                  </v-alert>
                </v-col>
                <v-col cols="12" :class="`${arabic?'arFont':'enFont'} pa-0 py-2`" v-if="result_ready && accepted">
                  <v-btn :class="`${arabic?'arFont':'enFont'}`" color="primary" block @click="openLink('https://events.aramccogermany.com/')">انجازات ارامكو</v-btn>
                </v-col>
                <v-col cols="12" style="font-size:18px;" :class="`${arabic?'arFont':'enFont'} pa-0 py-2`" v-if="result_ready && accepted">
                  <v-alert
                    icon="list"
                    border="top"
                    colored-border
                    type="success"
                    elevation="2"
                  >
                    <div class="pb-2">الخطوات المطلوبة</div>
                    <div class="pb-2">
                      <v-icon size="12" color="success" dark>check_circle</v-icon>
                      التواصل مع مكتبنا في
                      <span class="font-weight-bold">{{lead.country_name ? lead.country_name.ar : lead.country}}</span>
                      لحجز موعد مع القسم الخاص بالتسجيل في المانيا
                      لاكمال خطوات التسجيل وتوقيع العقد بشكل رسمي
                    </div>
                    <div class="pb-2">
                      <v-icon size="12" color="success" dark>check_circle</v-icon>
                      يجب ان يتم التواصل خلال ساعات الدوام قبل الساعة
                      <span>14:00</span>
                      من اليوم التالي لصدور الموافقة
                    </div>
                    <div class="pb-2">
                      <v-icon size="12" color="success" dark>check_circle</v-icon>
                      الاتصال لحجز موعد:
                    </div>
                    <v-col cols="12" style="font-size:12px;" :class="`${arabic?'arFont':'enFont'} pa-0 pb-2 font-weight-bold text-center`">
                      <v-row class="pa-0 align-center" v-if="lead.country_name && phones[lead.country_name.slug] && phones[lead.country_name.slug].length">
                        <v-col cols="12" style="font-size:12px;" :class="`${arabic?'arFont':'enFont'} pa-0 pb-1`" v-for="(tel, t) in shuffle(phones[lead.country_name.slug])" :key="t+'telefon'">
                          <v-row class="pa-0 align-center">
                            <v-col cols="6" style="font-size:14px;" :class="`${arabic?'arFont':'enFont'}`">
                              {{tel}}
                            </v-col>
                            <v-col cols="6" style="font-size:14px;" :class="`${arabic?'arFont':'enFont'}`">
                              <v-btn color="success" @click="call(tel)">اضغط للأتصال</v-btn>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-alert>
                </v-col>
                <iframe width="100%" height="315" :src="getLink()" title="YouTube video player" v-if="result_ready" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                <v-col cols="12" :class="`${arabic?'arFont':'enFont'} pa-0 py-2`" v-if="true || result_ready">
                  <v-btn :class="`${arabic?'arFont':'enFont'}`" color="primary" block @click="openLink('https://events.aramccogermany.com/')">انجازات ارامكو</v-btn>
                </v-col>

                <v-col cols="12" style="font-size:12px;" :class="`${arabic?'arFont':'enFont'} pa-0 pb-2 font-weight-bold text-center`" v-if="!result_ready || !accepted">
                  في حال وجود مشكلة او تأخر في صدور نتيجة ملف الترشح الخاص بك يمكنك الاتصال بمكاتبنا في بلدك بشكل مباشر للأستفسار
                </v-col>
                <v-col cols="12" style="font-size:12px;" :class="`${arabic?'arFont':'enFont'} pa-0 pb-2 font-weight-bold text-center`" v-if="!result_ready || !accepted">
                  <v-row class="pa-0 align-center" v-if="lead.country_name && phones[lead.country_name.slug] && phones[lead.country_name.slug].length">
                    <v-col cols="12" style="font-size:12px;" :class="`${arabic?'arFont':'enFont'} pa-0 pb-1`" v-for="(tel, t) in shuffle(phones[lead.country_name.slug])" :key="t+'telefon'">
                      <v-row class="pa-0 align-center">
                        <v-col cols="6" style="font-size:14px;" :class="`${arabic?'arFont':'enFont'}`">
                          {{tel}}
                        </v-col>
                        <v-col cols="6" style="font-size:14px;" :class="`${arabic?'arFont':'enFont'}`">
                          <v-btn color="success" small @click="call(tel)">اضغط للأتصال</v-btn>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" style="font-size:11px;" :class="`${arabic?'arFont':'enFont'} text-center px-6 py-1`" v-if="location">
                  {{location.country_code2}} | {{location.country_name}} | {{location.ip}} | <img height="10px" :src="location.country_flag" alt="">
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md="3" class="pa-0 ma-0">
        </v-col>
        <v-col cols="12" md="3" class="pa-0 ma-0">
        </v-col>
        <v-col cols="12" md="6" LOGO class="text-center py-5 align-center">
            <div style="font-size:12px;direction:ltr;">{{ footerdate }} &copy; {{company}}<sup>®</sup> <strong> | iaramcco.com</strong><sup>®</sup></div>
        </v-col>
        <v-col cols="12" md="3" class="pa-0 ma-0">
        </v-col>
        <v-col cols="12" md="3" class="pa-0 ma-0">
        </v-col>
        
        <v-col cols="12" md="3" class="pa-0 ma-0">
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { getRandomInt, randomString, getCDate, check, sleep } from '@/customFunction';
import { format, render, cancel, register } from 'timeago.js';
import {firebase, db, auth} from '@/fb'
import axios from 'axios';
const headers = {'Accept': 'application/json'};

export default {
  data() {
    return {
      loading:false,
      dialog:false,
      lead:null,
      interview:null,
      footerdate: new Date().toISOString().substr(0, 4),
      company:'ARAMCCO IN GERMANY',
      rules: {
        required: value => !!value || this.i18n['required'],
        email: value => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) || this.i18n['valid_email']
      },
      phones:{
        tunisia:['24331166', '28770077', '24331155'],
        morocco:['212702098692', '212703117026', '212702098244'],
        algeria:['213793505313', '213559270678'],
        algeria_aramcco:['213793505313', '213559270678'],
        egypt:['01281284080', '01228191615'],
        egypt_alexandria: ['01220460143'],
        palestine:['594883324', '0594883320', '2367755'],
        iraq_new:["7855300964"],
        morocco_tangier: ["212702098693"],
        jordan_new: ["781770309", "0781770308"],
        algeria_oran:['213793455152', '213797152748']
      },
      email:null,
      day:null,
      date:null,
      conditions:null,
      invitation:false,
      confirmation:false,
      conditions_met:[],
      confirmDetails:false,
      confirmedAppointment:false,
      start_answer:false,
      old:false,
      search_number:null,
      error:null,
      location:null,
      searchView:true,
      resultView:false,
      result_ready:false,
      accepted:false,
      last_date:false,
      last_time:false,
      last_day:false,
      phonelogin:true,
      emaillogin:false,
      search_email:null,
      voucherTime:null,
      voucherLink:null
    }
  },
  
  methods: {
    shuffle(array) {
      let currentIndex = array.length,  randomIndex;

      // While there remain elements to shuffle.
      while (currentIndex != 0) {

        // Pick a remaining element.
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;

        // And swap it with the current element.
        [array[currentIndex], array[randomIndex]] = [
          array[randomIndex], array[currentIndex]];
      }

      return array;
    },
    getLink() {
      let links = [
        'https://www.youtube.com/embed/LPefz6Q_hAo',
        'https://www.youtube.com/embed/9XA23N_gD-4',
        'https://www.youtube.com/embed/1hjwgC3B0ck',
        'https://www.youtube.com/embed/koUcqsDXIDc',
        'https://www.youtube.com/embed/3-gmf8lptYY',
      ]
      return links[getRandomInt(0, links.length)]
    },
    call(tel){
      window.open(`tel:${tel}`, '_blank').focus();
      try {
        gtag('event', `ACC_${this.location.country_code2}_click_call_${tel}`);
      } catch (error) {
        console.log(error)
      }
    },
    openLink(path){
      try {
        gtag('event', `open_link${this.old ? '_alt' : ''}`);
      } catch (error) {
        console.log(error)
      }
      window.open(path, '_blank').focus();
    },
    getFormat(d){
      return format(d)
    },
    async searchLead(){
      this.loading = true
      console.log(this.search_number)
      if(!this.search_number || this.search_number.length < 6) {
        this.$emit('snackbarNotification', `يرجى ادخال رقم هاتف صحيح`, 'error')
        try {
          gtag('event', `ACC_${this.location.country_code2}_open_short_number_${n}`);
        } catch (error) {
          console.log(error)
        }
        this.loading = false
        return true
      }
      let n = (parseInt(this.search_number.trim())).toFixed(0) // (parseInt(this.search_number.trim())).toFixed(0) // 
      let s = await axios.get(`https://aramccoonline.com/back/public/api/v1/searchnlead/${n}`).then(x=>x.data)
      console.log(s)
      if(!s.error) {
        this.lead = s.lead
        this.date = s.date
        this.day = s.day
        this.result_ready = s.result_ready
        this.accepted = s.accepted
        if(this.result_ready && this.accepted) {
          this.last_date = s.last_date
          this.last_time = s.last_time
          this.last_day = s.last_day
          this.voucherTime = s.voucher_time
          this.voucherLink = s.voucherLink
        }
        this.searchView = false
        this.resultView = true
        try {
          gtag('event', `ACC_${this.location.country_code2}_open_${this.result_ready?'ready':'not_ready'}`);
        } catch (error) {
          console.log(error)
        }
        try {
          if(this.result_ready) {
            gtag('event', `ACC_${this.location.country_code2}_open_${this.accepted?'accepted':'rejected'}`);
          }
        } catch (error) {
          console.log(error)
        }
      } else {
        this.error = true
        setTimeout(x=>this.error = false, 10000)
        try {
          gtag('event', `ACC_${this.location.country_code2}_cant_login_${n}`);
        } catch (error) {
          console.log(error)
        }
        this.$emit('snackbarNotification', `لم نتمكن من تسجيل دخولك، يرجى التواصل مع مكتبنا`, 'error')
      }
      this.loading = false
    },
    async searchLeadEmail(){
      this.loading = true
      if(!/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.search_email.trim())) {
        this.$emit('snackbarNotification', `يرجى ادخال ايميل صحيح`, 'error')
        try {
          gtag('event', `ACC_open_wrong_email`);
        } catch (error) {
          console.log(error)
        }
        this.loading = false
        return true
      }
      let e = this.search_email.trim()
      let s = await axios.get(`https://aramccoonline.com/back/public/api/v1/searchelead/${e}`).then(x=>x.data)
      console.log(s)
      if(!s.error) {
        this.lead = s.lead
        this.date = s.date
        this.day = s.day
        this.result_ready = s.result_ready
        this.accepted = s.accepted
        if(this.result_ready && this.accepted) {
          this.last_date = s.last_date
          this.last_time = s.last_time
          this.last_day = s.last_day
          this.voucherTime = s.voucher_time
          this.voucherLink = s.voucherLink
        }
        this.searchView = false
        this.resultView = true
        try {
          gtag('event', `ACC_${this.location.country_code2}_open_${this.result_ready?'ready':'not_ready'}`);
        } catch (error) {
          console.log(error)
        }
        try {
          if(this.result_ready) {
            gtag('event', `ACC_${this.location.country_code2}_open_${this.accepted?'accepted':'rejected'}`);
          }
        } catch (error) {
          console.log(error)
        }
      } else {
        this.error = true
        setTimeout(x=>this.error = false, 10000)
        try {
          gtag('event', `ACC_${this.location.country_code2}_cant_login_${n}`);
        } catch (error) {
          console.log(error)
        }
        this.$emit('snackbarNotification', `لم نتمكن من تسجيل دخولك، يرجى التواصل مع مكتبنا`, 'error')
      }
      this.loading = false
    },
    async getLocation(){
      return new Promise(async (res, rej)=>{
        this.loading = true
        let l = await axios.get(`https://aramccoonline.com/back/public/api/v1/location`).then(x=>x.data)
        this.location = l
        console.log(l)
        try {
          gtag('event', `iaramcco_open`);
          gtag('event', `ACC_${l.country_code2}_open`);
        } catch (error) {
          console.log(error)
        }
        this.loading = false
        res(true)
      })
    },
    async getRoute(){
      return new Promise(async (res, rej)=>{
        let a = this.$route.name
        
        res(a)
      })
    }
  },
  watch:{
  },
  computed:{
    site(){
      return this.$store.state.site
    },
    items() {
      return this.$store.state.menu
    },
    superAdmin(){
      return this.$store.state.superAdmin
    },
    isLogin() {
      return this.$store.state.centralLogin
    },
    language(){
      return this.$store.state.language
    },
    globalLoading(){
      return this.$store.state.globalLoading
    },
    user(){
      return this.$store.state.user
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
    routeTitle(){
      let main = this.$store.state.menu.filter(x=>x.path == this.$route.path)
      let sub = [].concat(...this.$store.state.menu.map(x=>x.subs)).filter(x=>x).filter(x=>x.path == this.$route.path)
      if(main.length) {
        return this.$store.state.i18n[this.$store.state.language][main[0].text]
      } else if(sub.length) {
        return this.$store.state.i18n[this.$store.state.language][sub[0].text]
      } else {
        return ''
      }
    },
    goalModel(){
      return this.$store.state.goalModel
    },
    keyResultModel(){
      return this.$store.state.keyResultModel
    },
    initModel(){
      return this.$store.state.initiativeModel
    },
    units(){
      return this.$store.state.units
    },
    quarters(){
      return this.$store.state.quarters
    },
    fileTypes(){
      return this.$store.state.fileTypes
    },
    notifications(){
      return this.$store.state.notifications.sort((a, b)=> b.timestamp - a.timestamp)
    },
  },
  async created(){
    await this.getRoute()
    await this.getLocation()
  },
  
}
</script>

<style>
.forceLTR * {
  direction:ltr !important;
  text-align: left !important;
}
.forceLTR label {
  right:unset!important;
}
</style>